const React = require("react");
const T = React.PropTypes;

const FileType = require("../types/FileType.js");
const TitledMessage = require("./TitledMessage.jsx");
const HttpResponse = require("./HttpResponse.jsx");
const Spinner = require("./Spinner.jsx");
const FileTypeItem = require("./FileTypeItem.jsx");

const FileTypeActionCreators = require("../actionCreators/FileTypeActionCreators.js");
const ValidExtensionActionCreators = require("../actionCreators/ValidExtensionActionCreators.js");

const styles = {
    Outer: {
        textAlign: "center",
        color: "#555",
    },
    SpinnerBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40%"
    },
    List: {
        padding: 0,
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        backgroundColor: "#eee",
        paddingLeft: "20%",
        paddingRight: "20%"
    },
    Item: {
        flex: "0 0 80px",
        margin: "30px 40px",
        height: 120,
        textAlign: "center"
    }
};

const FileTypeSelector = React.createClass({
    propTypes: {
        FileTypes: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(FileType.Type),
            LoadError: T.object
        }),
        ValidExtensions: T.shape({
            AreLoading: T.bool,
            Data: T.arrayOf(T.string),
            LoadError: T.object
        })
    },
    componentDidMount() {
        if ((this.props.FileTypes.Data || []).length === 0) {
            FileTypeActionCreators.Get();
        }

        if ((this.props.ValidExtensions.Data || []).length === 0) {
            ValidExtensionActionCreators.Get();
        }
    },
    render() {
        const style = Object.assign({}, this.props.style || {}, styles.Outer);

        let children = null;

        const isLoading =
            (this.props.FileTypes.Data || []).length === 0
            || (this.props.ValidExtensions.Data || []).length === 0;

        if (this.props.FileTypes.LoadError) {
            const response = this.props.FileTypes.LoadError.response;

            children = this.GetError(response);
        }
        else if(this.props.ValidExtensions.LoadError)
        {
            const response = this.props.ValidExtensions.LoadError.response;

            children = this.GetError(response);
        }
        else if (isLoading) {
            children = (<article style={style}>
                <div style={styles.SpinnerBox}>
                    <Spinner Message="Loading..." WithTimer={true} Large={true } />
                </div>
            </article>);
        }
        else {
            const types = this.GetFileTypes();

            children = (<div>
                <h1>
                    What kind of file(s) do you want to upload?
                </h1>
                <h2>
                    Pick one from the list below.
                </h2>
                <div style={styles.List }>
                    {types}
                </div>
            </div>);
        }

        return (<article style={style}>
            {children}
        </article>);
    },
    GetFileTypes() {
        const types = this.props.FileTypes.Data.map((t) => {
            return (<FileTypeItem style={styles.Item} key={t.PKID} FileType={t } />);
        });

        return types;
    },
    GetError(response) {
        return (<TitledMessage Title="We got problems." 
                        Subtitle="Kindly try reloading this page.  If you keep getting this error, please contact support with the following information:">
            <HttpResponse Response={response} style={{ margin: "30px 20%" }} />
        </TitledMessage>);
    }
});

module.exports = FileTypeSelector;


// WEBPACK FOOTER //
// ./src/components/FileTypeSelector.jsx